 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Branch
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryBranchFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryBranchFilterForm"
                            v-model="filtersBranch.branch"
                            :label="filtersBranchLabel.branch"
                            :error-messages="errors.collect('filterBranch')"
                            data-vv-name="filterBranch"
                            :data-vv-as="filtersBranchLabel.branch"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearBranchFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doBranchFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="branchHeaders"
          :items="branchItems"
          v-bind:options.sync="paginationBranch"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsBranch"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.branch }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignBranch(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { creditNoteFilterMixin } from '@/mixins/accounting/creditNote/creditNoteFilterMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      branchHeaders: [
        { text: 'Branch', value: 'branch' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      totalItemsBranch: 0,
      branchItems: [],
      paginationBranch: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.doClearBranchFilters()
  },
  methods: {
    closeDialog() {
      this.filtersBranch.branch = ''
      this.$emit('close')
    },
    doClearBranchFilters() {
      this.filtersBranch.branch = ''
      this.fetchBranchData()
    },
    doBranchFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryBranchFilterForm').then((result) => {
        if (result) {
          this.paginationBranch.page = 1
          this.fetchBranchData()
        }
      })
    },
    assignBranch(data) {
      this.$emit('assign-branch', data.branch)
      this.$emit('close')
    }
  },
  computed: {},
  mixins: [TableConst.default, creditNoteFilterMixin, commonAjaxMixin]
}
</script>
